import PriceCell from '../price-cell/PriceCell';
import { BoxProps } from '@mui/material';
import { fetchPriceRequest } from '../../redux/slice/pricesSlice';
import { getPriceCatalogKey, isPriceInLoadingStage } from '../../utils/equipment';
import { Price } from '../../types/equipment';
import { RootState, useAppDispatch, useAppSelector } from '../../redux/store';
import { useEffect, useState } from 'react';
import { PricingContainer, PricingLabelContainer } from './PriceWidgetStyle';
import PriceLabel from '../price-label/PriceLabel';
import { isValidFourWeekPrice } from '@app/utils/price';


interface PriceWidgetProps extends BoxProps {
  equipmentId: string | number;
  day?: boolean;
  week?: boolean;
  month?: boolean;
  showDecimal?: boolean;
}

function PriceWidget({ equipmentId, day, week, month, showDecimal, ...rest }: PriceWidgetProps) {
  const dispatch = useAppDispatch();

  const branchId = useAppSelector((state: RootState) => state.location.branch?.branch_id);

  const [price, setPrice] = useState<Price | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const priceEntry = useAppSelector((state: RootState) => state.prices.priceCatalog[getPriceCatalogKey(equipmentId)]);

  const getConditionalPrice = (value: number | undefined): number | undefined => {
    return value && isValidFourWeekPrice(price?.price_per_month) ? value : undefined;
  }

  useEffect(() => {
    setPrice(priceEntry?.price ?? null);
    const loadingStatus = branchId && priceEntry ? isPriceInLoadingStage(priceEntry.status) : false;
    setIsLoading(loadingStatus);
  }, [priceEntry]);

  useEffect(() => {
    if (equipmentId) {
      dispatch(
        fetchPriceRequest({
          equipmentId
        }),
      );
    }
  }, []);

  return (
    <PricingLabelContainer {...rest}>
      <PriceLabel equipmentId={equipmentId} isLoading={isLoading}></PriceLabel>
      <PricingContainer
        className='pricing-container'>
        {day && (
          <PriceCell
            className='price-cell'
            amount={getConditionalPrice(price?.price_per_day)}
            unit={'day'}
            isLoading={isLoading}
            showDecimal={showDecimal}
          />
        )}
        {week && (
          <PriceCell
            className='price-cell'
            amount={getConditionalPrice(price?.price_per_week)}
            unit={'week'}
            isLoading={isLoading}
            showDecimal={showDecimal}
          />
        )}
        {month && (
          <PriceCell
            className='price-cell'
            amount={getConditionalPrice(price?.price_per_month)}
            unit={'4-week'}
            isLoading={isLoading}
            showDecimal={showDecimal}
          />
        )}
      </PricingContainer>
    </PricingLabelContainer>
  );
}

export default PriceWidget;
